/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchEquipmentIdentifierResponse } from './search-equipment-identifier-response';


export interface SearchEquipmentIdentifierResponsePagedList { 
    totalCount?: number;
    items?: Array<SearchEquipmentIdentifierResponse> | null;
}

